import * as React from "react";
import { PricedAddToCartCTA } from "../../../../../../../../PricedAddToCartCTA/modules/EcommContent/ContactLensesEcommContent/components/ContactLensesCTA/components/PricedAddToCartCTA/PricedAddToCartCTA.js";
import { useProductData } from "../../../../../../../../../../../../../../context/context/product-context-hooks.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
import { useCartDiscountsQuery } from "../../../../../../../../../../../../../../hooks/useCartDiscountsQuery/hooks/useCartDiscountsQuery/use-cart-discounts-query.js";
import { getProductTealiumDescription } from "../../../../../../../../../../../../../../utils/utils/get-product-tealium-description.js";
import { isSubscriptionPurchase } from "../../../../../../../../../../../../../../types/types/typeguards.js";
const CLAddToCartCTA = ({ className, lineItemDrafts }) => {
  const { displayPrice, activeVariant, product } = useProductData();
  const { promotionIdentifier } = activeVariant;
  const { state, selectors } = useCLEcommContext();
  const totalSelectedQuantity = selectors.getEnabledSelectedQuantity(state);
  const { activeDiscount } = useCartDiscountsQuery(
    promotionIdentifier,
    totalSelectedQuantity || void 0
  );
  const isLoading = selectors.hasQueryLoading(state);
  const totalPrice = selectors.getTotalPurchasePrice(state, displayPrice, activeDiscount);
  const { purchaseType } = state.configurations;
  const { deliveryInterval } = state.configurations.subscriptionPurchaseConfigurations;
  const priceInterval = isSubscriptionPurchase(purchaseType) && !!deliveryInterval ? deliveryInterval : void 0;
  return /* @__PURE__ */ React.createElement(
    PricedAddToCartCTA,
    {
      className,
      lineItemDrafts,
      price: totalPrice,
      isCentAmount: false,
      priceInterval,
      isLoading,
      "data-element-id": "Prod_AddCart",
      "data-description": getProductTealiumDescription(product.name, activeVariant.sku)
    }
  );
};
export {
  CLAddToCartCTA
};
//# sourceMappingURL=CLAddToCartCTA.js.map
